import { CSSProperties } from "react";

export const XTechNegociator = ({
  width,
  style,
}: {
  width: number;
  style?: CSSProperties;
}) => {
  return (
    <svg
      width={width}
      height={width}
      viewBox="0 0 70 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <circle
        cx="35"
        cy="35"
        r="34.5"
        fill="url(#paint0_radial_507_16)"
        stroke="#343434"
      />
      <path
        d="M55.1267 37.5277L55.5002 37.4299L55.5 37.0438L55.498 32.9576L55.4978 32.5722L55.1251 32.4743L50.8971 31.3628C50.493 29.7525 49.8209 28.2437 48.9357 26.8748L51.0912 23.2656L51.2964 22.9219L51.0061 22.6465L47.9619 19.7583L47.6991 19.509L47.3803 19.681L43.554 21.7451C42.0991 20.8923 40.4995 20.2499 38.7928 19.862L37.6257 15.86L37.5207 15.5H37.1457H32.8498H32.4749L32.3698 15.8598L31.2008 19.8621C29.4977 20.2499 27.897 20.8922 26.4454 21.7449L22.6149 19.6809L22.2959 19.509L22.0333 19.7586L18.9911 22.649L18.7011 22.9245L18.9063 23.268L21.0599 26.8711C20.1746 28.2438 19.504 29.7529 19.0951 31.3626L14.8727 32.4744L14.5 32.5725V32.9579V37.044V37.4297L14.8731 37.5276L19.0951 38.6355C19.4976 40.2225 20.1608 41.7384 21.0597 43.1274L18.9062 46.7365L18.7012 47.0801L18.9915 47.3555L22.0337 50.2416L22.2962 50.4907L22.6148 50.3191L26.4455 48.2568C27.9175 49.1197 29.5241 49.7538 31.2046 50.1359L32.3696 54.1397L32.4745 54.5002L32.8499 54.5L37.1481 54.4981L37.5231 54.4979L37.6279 54.1378L38.7929 50.136C40.4996 49.7481 42.0991 49.1058 43.5537 48.2547L47.3845 50.3212L47.7039 50.4935L47.9667 50.2432L51.0025 47.3528L51.2916 47.0776L51.0872 46.7347L48.9353 43.1251C49.8186 41.7549 50.4909 40.2475 50.8967 38.6355L55.1267 37.5277ZM24.158 30.7644L30.5014 24.738H39.4981L45.8395 30.7644V30.7914H41.9349C40.4701 28.6063 37.9047 27.1625 34.9997 27.1625C32.0949 27.1625 29.5295 28.6063 28.0647 30.7914H24.158V30.7644ZM34.9997 31.8701C36.8576 31.8701 38.3212 33.297 38.3212 34.9991C38.3212 36.7072 36.8576 38.1319 34.9997 38.1319C33.1426 38.1319 31.6785 36.7073 31.6785 34.9991C31.6785 33.297 33.1424 31.8701 34.9997 31.8701ZM45.8396 39.2663L39.4981 45.2927H30.5014L24.1581 39.2663V39.2067H28.0577C28.3838 39.6939 28.7651 40.1453 29.1947 40.5529C30.749 42.0294 32.8128 42.8393 34.9997 42.8393C37.1875 42.8393 39.2513 42.0292 40.8057 40.5525C41.2351 40.145 41.6162 39.6937 41.9423 39.2067H45.8396V39.2663Z"
        fill="white"
        stroke="black"
      />
      <defs>
        <radialGradient
          id="paint0_radial_507_16"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(35 35) rotate(90) scale(35)"
        >
          <stop stopColor="#9CB19C" />
          <stop offset="1" stopColor="#118211" />
        </radialGradient>
      </defs>
    </svg>
  );
};
